module.exports = __webpack_public_path__ + "static/media/airtable_thumbnail.ab17af1e.png";